import React from 'react';
import classnames from 'classnames';

import classes from './Modal.scss';

type ModalStaticProps = {
    children: React.ReactNode;
    className?: string;
    isMob: boolean;
    isOpen?: boolean;
    onDismiss?(...args: any[]): void;
};

export function ModalStatic(props: ModalStaticProps) {
    return (
        <>
            <div
                className={classnames({
                    [props.className ?? '']: true,
                    [classes.static]: true,
                    [classes.staticActive]: props.isOpen,
                })}
                data-smooth-scroll="ModalStatic"
            >
                {props.children}
            </div>
            {props.isOpen && props.isMob && (
                <button
                    className={[classes.overlay, classes.overlayStatic].join(' ')}
                    type="button"
                    onClick={props.onDismiss}
                >
                    &nbsp;
                </button>
            )}
        </>
    );
}

ModalStatic.defaultProps = {
    isOpen: false,
};
